var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlantisLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "100 100 350 270",
    width: 550,
    height: 470,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 124.58931,
    y1: 235,
    x2: 425.41069,
    y2: 235,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00968f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fff4"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "url(\"#color-1\")",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-paper-data": "{\"isGlobalGroup\":true,\"bounds\":{\"x\":124.58930595949516,\"y\":115,\"width\":300.8213880810097,\"height\":240}}",
    fill: "url(\"#color-1\")"
  }, /*#__PURE__*/React.createElement("g", {
    "data-paper-data": "{\"isPrimaryText\":true}",
    fill: "url(\"#color-1\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.8615,245.28714h-25.80678l-5.76787,12.01145h-4.69755l21.52547,-43.76449c0.39642,-0.79283 1.01086,-1.18925 1.84334,-1.18925c0.83248,0 1.44692,0.39642 1.84334,1.18925l21.64439,43.76449h-4.57862zM158.83977,241.12476l-10.88166,-22.00117l-10.88166,22.00117z",
    "data-paper-data": "{\"glyphName\":\"A\",\"glyphIndex\":0,\"firstGlyphOfWord\":true,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.19199,212.76109h32.22874v4.10292h-14.03318v40.43458h-4.16238v-40.43458h-14.03318z",
    "data-paper-data": "{\"glyphName\":\"T\",\"glyphIndex\":1,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22809,253.13621l-1.24871,4.16238h-25.98516c-0.55498,0 -1.0406,-0.20812 -1.45683,-0.62436c-0.41624,-0.41624 -0.62436,-0.90185 -0.62436,-1.45683v-42.45631h4.16238v40.37512z",
    "data-paper-data": "{\"glyphName\":\"L\",\"glyphIndex\":2,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.90053,245.28714h-25.80678l-5.76787,12.01145h-4.69755l21.52547,-43.76449c0.39642,-0.79283 1.01086,-1.18925 1.84334,-1.18925c0.83248,0 1.44692,0.39642 1.84334,1.18925l21.64439,43.76449h-4.57862zM282.8788,241.12476l-10.88166,-22.00117l-10.88166,22.00117z",
    "data-paper-data": "{\"glyphName\":\"A\",\"glyphIndex\":3,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65987,257.65537c-0.71355,0 -1.26854,-0.29731 -1.66495,-0.89194l-25.03376,-35.73703v36.2722h-4.16238v-42.87255c0,-0.43606 0.12884,-0.84239 0.38651,-1.21898c0.25767,-0.3766 0.60454,-0.62436 1.0406,-0.74328c0.43606,-0.15857 0.87212,-0.15857 1.30818,0c0.43606,0.15857 0.77301,0.41624 1.01086,0.77301l25.09323,35.7965v-36.2722h4.10292v42.81309c0,0.4757 -0.12884,0.89194 -0.38651,1.24871c-0.25767,0.35678 -0.60454,0.61445 -1.0406,0.77301c-0.15857,0.03964 -0.3766,0.05946 -0.65409,0.05946z",
    "data-paper-data": "{\"glyphName\":\"N\",\"glyphIndex\":4,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.92518,212.76109h32.22874v4.10292h-14.03318v40.43458h-4.16238v-40.43458h-14.03318z",
    "data-paper-data": "{\"glyphName\":\"T\",\"glyphIndex\":5,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.64621,212.76109h4.16238v44.5375h-4.16238z",
    "data-paper-data": "{\"glyphName\":\"I\",\"glyphIndex\":6,\"word\":1}",
    fill: "url(\"#color-1\")"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77203,233.03784c1.9028,0.39642 3.7957,0.84239 5.67868,1.33791c1.88298,0.49552 3.55785,1.17934 5.02459,2.05146c1.46674,0.87212 2.656,2.01182 3.56776,3.4191c0.91176,1.40728 1.36764,3.24071 1.36764,5.50029c0,3.88489 -1.41719,6.90757 -4.25158,9.06805c-2.83438,2.16048 -6.78865,3.24071 -11.86279,3.24071c-5.07414,0 -9.0185,-1.08024 -11.83306,-3.24071c-2.81456,-2.16048 -4.22185,-5.18316 -4.22185,-9.06805h4.16238c0,1.78388 0.40633,3.21098 1.21898,4.28131c0.81266,1.07033 1.82352,1.9028 3.03259,2.49743c1.20907,0.59463 2.50734,0.98113 3.8948,1.15952c1.38746,0.17839 2.63618,0.26758 3.74614,0.26758c1.10997,0 2.35868,-0.08919 3.74614,-0.26758c1.38746,-0.17839 2.68573,-0.56489 3.8948,-1.15952c1.20907,-0.59463 2.22985,-1.4271 3.06232,-2.49743c0.83248,-1.07033 1.24871,-2.49743 1.24871,-4.28131c0,-1.22889 -0.19821,-2.25958 -0.59463,-3.09206c-0.39642,-0.83248 -1.07033,-1.54603 -2.02173,-2.14065c-0.9514,-0.59463 -2.21994,-1.12979 -3.80561,-1.60549c-1.58567,-0.4757 -3.56776,-0.9514 -5.94626,-1.4271c-1.9028,-0.39642 -3.7957,-0.84239 -5.67868,-1.33791c-1.88298,-0.49552 -3.55785,-1.17934 -5.02459,-2.05146c-1.46674,-0.87212 -2.656,-2.02173 -3.56776,-3.44883c-0.91176,-1.4271 -1.36764,-3.27044 -1.36764,-5.53002c0,-3.88489 1.40728,-6.91748 4.22185,-9.09778c2.81456,-2.1803 6.75892,-3.27044 11.83306,-3.27044c5.07414,0 9.02841,1.09015 11.86279,3.27044c2.83438,2.1803 4.25158,5.21289 4.25158,9.09778h-4.16238c0,-1.78388 -0.41624,-3.21098 -1.24871,-4.28131c-0.83248,-1.07033 -1.85325,-1.9028 -3.06232,-2.49743c-1.20907,-0.59463 -2.50734,-0.98113 -3.8948,-1.15952c-1.38746,-0.17839 -2.63618,-0.26758 -3.74614,-0.26758c-1.10997,0 -2.35868,0.08919 -3.74614,0.26758c-1.38746,0.17839 -2.68573,0.56489 -3.8948,1.15952c-1.20907,0.59463 -2.21994,1.4271 -3.03259,2.49743c-0.81266,1.07033 -1.21898,2.49743 -1.21898,4.28131c0,1.22889 0.20812,2.25958 0.62436,3.09206c0.41624,0.83248 1.10997,1.55594 2.08119,2.17039c0.97122,0.61445 2.23976,1.15952 3.80561,1.63522c1.56585,0.4757 3.5182,0.9514 5.85707,1.4271z",
    "data-paper-data": "{\"glyphName\":\"S\",\"glyphIndex\":7,\"lastGlyphOfWord\":true,\"word\":1}",
    fill: "url(\"#color-1\")"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.14678,150.14689c11.07218,-11.0719 23.7866,-19.64399 38.14326,-25.71627c14.86442,-6.28708 30.43441,-9.43061 46.70996,-9.43061c16.27555,0 31.84553,3.14354 46.70996,9.43061c14.35666,6.07243 27.07108,14.64452 38.14326,25.71627c11.07171,11.07218 19.6438,23.7866 25.71627,38.14326c2.60778,6.16566 4.67471,12.45272 6.2008,18.86117l-2.11643,0.02994c-1.48869,-6.14281 -3.48391,-12.17165 -5.98565,-18.08652c-5.96783,-14.10982 -14.3928,-26.60579 -25.27492,-37.48791c-10.88212,-10.88203 -23.37809,-19.30695 -37.48791,-25.27478c-14.60726,-6.17839 -29.90905,-9.26759 -45.90538,-9.26759c-15.99633,0 -31.29812,3.0892 -45.90538,9.26759c-14.10982,5.96783 -26.60579,14.39275 -37.48791,25.27478c-10.88212,10.88259 -19.30709,23.37856 -25.27492,37.48791c-2.48696,5.88011 -4.47336,11.87277 -5.95921,17.97797l-2.11816,-0.02497c1.52366,-6.37262 3.58236,-12.62514 6.17608,-18.75758c6.07247,-14.35666 14.64457,-27.07108 25.71627,-38.14326zM385.56949,281.71006c-6.07247,14.35666 -14.64457,27.07108 -25.71627,38.14326c-11.07218,11.07171 -23.7866,19.6438 -38.14326,25.71627c-14.86442,6.28694 -30.43441,9.4304 -46.70996,9.4304c-16.27555,0 -31.84553,-3.14347 -46.70996,-9.4304c-14.35666,-6.07247 -27.07108,-14.64457 -38.14326,-25.71627c-11.07171,-11.07218 -19.6438,-23.7866 -25.71627,-38.14326c-2.75511,-6.514 -4.90653,-13.1635 -6.45428,-19.9485l2.17406,0.23578c1.50786,6.42697 3.56836,12.72968 6.18151,18.90814c5.96783,14.10982 14.3928,26.60579 25.27492,37.48791c10.88212,10.88212 23.37809,19.30709 37.48791,25.27492c14.60726,6.17806 29.90905,9.26709 45.90538,9.26709c15.99679,0 31.29859,-3.08903 45.90538,-9.26709c14.10982,-5.96783 26.60579,-14.3928 37.48791,-25.27492c10.88212,-10.88212 19.30709,-23.37809 25.27492,-37.48791c2.49586,-5.90095 4.48757,-11.91534 5.97513,-18.04315l2.11785,0.02476c-1.5252,6.39523 -3.5891,12.66956 -6.1917,18.82297z",
    "data-paper-data": "{\"isLogoContainer\":true}",
    fill: "url(\"#color-1\")"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlantisLogo);
export default __webpack_public_path__ + "static/media/atlantis_logo.406f8afdc0972519ce1601b8b9a6efc5.svg";
export { ForwardRef as ReactComponent };